// Integrazione Clerk flag-gated: si accende SOLO se la publishable key è in
// env (apps/web/.env.local → VITE_CLERK_PUBLISHABLE_KEY). Senza chiave l'app
// resta al login/registrazione nativi senza alcun cambiamento.
export const CLERK_ENABLED = !!import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

// La chiave va passata esplicitamente al provider: l'auto-lettura del
// pacchetto (getEnvVariable) cerca import.meta.env A RUNTIME, ma nei dep
// pre-bundlati da Vite quell'oggetto non esiste nel browser — la chiave non
// verrebbe mai trovata e clerk-js non si caricherebbe (pagina login vuota).
// Qui siamo codice dell'app: Vite la inietta a build-time.
export const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
